import { render, staticRenderFns } from "./NotificationsModal.vue?vue&type=template&id=1500f31b"
import script from "./NotificationsModal.vue?vue&type=script&lang=ts"
export * from "./NotificationsModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports